import type { RouteRecordRaw } from 'vue-router'

// Children of /organize/:slug. Pages lazy-load.
export const organizeRoutes: RouteRecordRaw[] = [
  { path: '', name: 'organize.overview', component: () => import('./pages/Overview.vue') },
  { path: 'auth', name: 'organize.auth', component: () => import('./Auth.vue') },
  { path: 'roster', name: 'organize.roster', component: () => import('./pages/Roster.vue') },
  { path: 'requests', name: 'organize.requests', component: () => import('./pages/Requests.vue') },
  { path: 'matcher', name: 'organize.matcher', component: () => import('./pages/Matcher.vue') },
  { path: 'attendance', name: 'organize.attendance', component: () => import('./pages/Attendance.vue') },
  { path: 'surveys', name: 'organize.surveys', component: () => import('./pages/Surveys.vue') },
  { path: 'announcements', name: 'organize.announcements', component: () => import('./pages/Announcements.vue') },
  { path: 'help', name: 'organize.help', component: () => import('./pages/Help.vue') },
  { path: 'board', name: 'organize.board', component: () => import('./pages/Board.vue') },
  { path: 'draw', name: 'organize.draw', component: () => import('./pages/Draw.vue') },
  { path: 'prizes', name: 'organize.prizes', component: () => import('./pages/Prizes.vue') },
  { path: 'bonus', name: 'organize.bonus', component: () => import('./pages/Bonus.vue') },
  { path: 'table-codes', name: 'organize.tablecodes', component: () => import('./pages/TableCodes.vue') },
  { path: 'insights', name: 'organize.insights', component: () => import('./pages/Insights.vue') },
  { path: 'settings', name: 'organize.settings', component: () => import('./pages/Settings.vue') },
  { path: 'sessions', name: 'organize.sessions', component: () => import('./pages/Sessions.vue') },
]
